import { ModalText } from '../../modal-prevent/types';

export const getPreventTextLiveBeforeRecordingsUpload = (): ModalText => ({
  title: ['Wait! There are recordings that are not done uploading.', 'Are you sure you want to leave?'],
  message: 'Choosing to leave before the upload is complete will delete the recordings.',
  cancelText: 'Leave & Delete',
  approveText: 'Stay',
});

export const checkChangeResource = (currentRoute: string, nextRoute: string): boolean => currentRoute !== nextRoute;
